<div class="vincent_about2">
    <div class="row">
        <div class="col col-12 vincent_content">
            <div class="row vincent_reservation" style="flex-direction: row-reverse;">
                <div class="col col-12 vincent_reservation_block ">
                    <div class="relative-bottom">
                        <h1> {{"invalied_page_for_users" | translate}}</h1>
                        <p style="font-size: 40px;"><mdb-icon fas icon="exclamation-triangle"></mdb-icon></p>
                        <img src="assets/imgs/separator_dark.png" alt="">
                        <p>{{"invalied_page_for_users_discreption" | translate}}</p>
                        <div class="vincent_form_block">
                            <a class="vincent_button" (click)="logout()">{{"Log_out" | translate}} </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>